<template>
  <div>
    <div class="folder-row" v-if="!game.flags.manualFolders">
      <div v-if="!levels.easy && !levels.medium && !levels.hard">
        Loading...
      </div>

      <div class="folder f-easy"  v-if="levels.easy">
        <div class="plus-label click" @click="goAddQuestion({ folderID: levels.easy._id })">
          <img src="../img/plus.svg" alt="">
          Easy Question
        </div>
        <div class="folder-icon click" @click="goViewFolder({ folderID: levels.easy._id })">
          <img src="../img/folder.svg" alt="">
        </div>
        <!-- <span class="action" v-if="levels.easy" @click="goAddQuestion({ folderID: levels.easy._id })">+ Add Easy Question</span>
        <span class="action" v-if="levels.easy" @click="goViewFolder({ folderID: levels.easy._id })">View Easy Folder</span> -->
      </div>

      <div class="folder f-medium"  v-if="levels.medium">
        <div class="plus-label click" @click="goAddQuestion({ folderID: levels.medium._id })">
          <img src="../img/plus.svg" class="plus" alt="">
          Medium Question
        </div>

        <div class="folder-icon click" @click="goViewFolder({ folderID: levels.medium._id })">
          <img src="../img/folder.svg" alt="">
        </div>
        <!-- <span class="action" v-if="levels.medium" @click="goAddQuestion({ folderID: levels.medium._id })">+ Add Medium Question</span>
        <span class="action" v-if="levels.medium" @click="goViewFolder({ folderID: levels.medium._id })">View Medium Folder</span> -->
      </div>

      <div class="folder f-hard" v-if="levels.hard">
        <div class="plus-label click" @click="goAddQuestion({ folderID: levels.hard._id })">
          <img src="../img/plus.svg" class="plus" alt="">
          Hard Question
        </div>

        <div class="folder-icon click" @click="goViewFolder({ folderID: levels.hard._id })">
          <img src="../img/folder.svg" alt="">
        </div>
        <!-- <span class="action" v-if="levels.hard" @click="goAddQuestion({ folderID: levels.hard._id })">+ Add Hard Question</span>
        <span class="action" v-if="levels.hard" @click="goViewFolder({ folderID: levels.hard._id })">View Hard Folder</span> -->
      </div>

      <!-- <pre>{{ levels }}</pre> -->
    </div>
    <div class="advanced-row">
      <div>
        <div>
          Advanced Settings <input type="checkbox" v-model="game.flags.manualFolders" @change="$emit('updateFlags', { game: game })" />
        </div>
      </div>
      <div class="id-row" v-if="game.flags.manualFolders">
        <div class="id-item">
          <input type="text" @input="onManualInput({ level: 'easy' })" v-model="game.question.easy">
          <div class="view-button" @click="goFolderTag({ tag: game.question.easy })">
            Go View Easy Folder
          </div>
        </div>
        <div class="id-item">
          <input type="text" @input="onManualInput({ level: 'medium' })" v-model="game.question.medium">
          <div class="view-button" @click="goFolderTag({ tag: game.question.medium })">
            Go View Medium Folder
          </div>
        </div>
        <div class="id-item">
          <input type="text" @input="onManualInput({ level: 'hard' })" v-model="game.question.hard">
          <div class="view-button" @click="goFolderTag({ tag: game.question.hard })">
            Go View Hard Folder
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import * as Folder from '../../../api/folders.js'
import axios from 'axios'
import * as QS from '../yoqb-compos/question.js'
// import { FDB, toArr } from '../game/firebase.js'

export default {
  props: {
    game: {}
  },
  data () {
    return {
      levels: {
        easy: false,
        medium: false,
        hard: false
      }
    }
  },
  async mounted () {
    console.log(this.game)
    this.gameID = this.game._id
    // Folder.getFolderByTitle({ title: '' })
    this.tryPopulateFolder()
  },
  methods: {
    onManualInput ({ level }) {
      this.$emit('update', { game: this.game })
    },
    async tryPopulateFolder () {
      if (!this.game.flags.manualFolders) {
        await Promise.all([
          this.provideFolder({ suffix: 'easy' })
            .then((data) => {
              this.game.question.easy = data.title
              this.$emit('update', { game: this.game })
              // if (process.env.NODE_ENV === 'production') {
              //   FDB.ref(`/user-games/${this.gameID}/easyQuestion`).set(data.title)
              // }
              this.levels.easy = data
            }),
          this.provideFolder({ suffix: 'medium' })
            .then((data) => {
              this.game.question.medium = data.title
              this.$emit('update', { game: this.game })

              // if (process.env.NODE_ENV === 'production') {
              //   FDB.ref(`/user-games/${this.gameID}/mediumQuestion`).set(data.title)
              // }
              this.levels.medium = data
            }),
          this.provideFolder({ suffix: 'hard' })
            .then((data) => {
              this.game.question.hard = data.title
              this.$emit('update', { game: this.game })

              // if (process.env.NODE_ENV === 'production') {
              //   FDB.ref(`/user-games/${this.gameID}/hardQuestion`).set(data.title)
              // }
              this.levels.hard = data
            })
        ])
      }
    },
    async goFolderTag ({ tag }) {
      // console.log(tag)
      // let resp = await Folder.getFolderByTitle({ title: tag })
      // console.log(resp.data)
      let resp = await Folder.matchFolderTags({
        tags: tag
      })
      let folders = resp.data
      let folder = folders[0]
      this.goViewFolder({ folderID: folder._id })
    },
    goViewFolder ({ folderID }) {
      this.$router.push(`/cloud/yoqb-folder/${folderID}`)
    },
    goAddQuestion ({ folderID }) {
      let headers = {}
      let jwt = window.localStorage.getItem('teacher-jwt')
      let uid = window.localStorage.getItem('teacher-uid')
      headers['Authorization'] = `bearer ${jwt}`
      // let data = {}
      axios({
        baseURL: 'https://yoteach-cloud.herokuapp.com',
        // baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://yoteach-cloud.herokuapp.com',
        url: '/jwt/question/add',
        headers,
        method: 'post',
        data: {
          folderID,
          userID: uid,
          document: QS.makeSampleQuestion(),
          questionOnly: QS.makeSampleQuestion(),
          title: `Question`
        }
      }).then((resp) => {
        let data = resp.data
        let questionID = data._id
        this.$router.push(`/cloud/yoqb-maker/${questionID}`)
      })
    },
    provideFolder ({ suffix }) {
      let title = `${this.game._id}-${suffix}`
      return Folder.getFolderByTitle({ title })
        .then((resp) => {
          console.log(resp)
          return resp.data
        }, () => {
          let jwt = window.localStorage.getItem('teacher-jwt')
          let uid = window.localStorage.getItem('teacher-uid')
          // console.log(jwt)
          let headers = {}
          headers['Authorization'] = `bearer ${jwt}`
          return axios({
            headers,
            method: 'post',
            baseURL: 'https://yoteach-cloud.herokuapp.com',
            // baseURL: process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : 'https://yoteach-cloud.herokuapp.com',
            url: '/jwt/folder/add',
            data: {
              title,
              desc: title,
              userID: uid,
              tags: [
                title
              ]
            }
          }).then((resp) => {
            console.log(resp)
            return resp.data
          })
        })
    }
  }
}
</script>

<style scoped>
/* .action{
  margin: 5px 10px;
  margin-left: 0px;
  display: inline-block;
  text-decoration: underline;
  cursor: pointer;
} */

.id-item{
  width: 33%;
}
.id-item input{
  font-size: 14px;
  padding: 9px;
}

.folder-row{
  min-height: 60px;
  width: calc(100% - 10px * 2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
}

@media screen and (min-width: 767px) {
  .folder-row{
    flex-direction: row;
  }
}

.folder{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  font-size: 14px;

}

.plus-label{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: grey;
  height: 30px;
  border-radius: 30px;
  padding: 0px 15px;
}
.plus-label img{
  width: 15px;
  height: 15px;
  margin-right: 10px;
}
.folder-icon{
  margin: 5px;

  display: flex;
  justify-content: center;
  align-items: center;
  background-color: grey;
  height: 30px;
  width: 30px;
  border-radius: 30px;
}
.folder-icon img{
  width: 15px;
  height: 15px;
}

.f-easy .plus-label{
  background-color: #A2F470;
}
.f-medium .plus-label{
  background-color: #F8C460;
}
.f-hard .plus-label{
  background-color: #F85C5C;
}

.f-easy .folder-icon{
  background-color: #A2F470;
}
.f-medium .folder-icon{
  background-color: #F8C460;
}
.f-hard .folder-icon{
  background-color: #F85C5C;
}
.view-button{
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(91, 93, 238);
  height: 30px;
  border-radius: 30px;
  padding: 0px 15px;
  color: white;
  margin-top: 10px;
}
.advanced-row{
  background-color: rgb(223, 223, 223);
  border-radius: 30px;
  padding: 5px 15px;
  font-size: 14px;
  padding-top: 15px;
  padding-bottom: 15px;
}

.id-row{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0px;
}
.id-item{
  display: flex;
  flex-direction: column;
}
.id-row input{
  border-radius: 30px;
  border: none;
  appearance: none;
  box-shadow: none;

}

</style>
